
interface ICodeParse {
  [key:string]:ICodeParse | string;
}
const result:Record<string, string> | undefined = undefined;
const codeParse:ICodeParse = {
  // 平台留言
  internal: {
    'A_0': '未知错误',
    'A_1': 'Could not get configuration for Tiger',
    'A_2': 'Could not parse string into json',
    'A_5': '参数格式不正确',
    'AT_0': '上课时长已存在',
    'AT_3': '试听课仅支持提前半小时约课／调课／取消',
    'AT_4': '试听课仅支持提前半小时约课／调课／取消',
    'AT_5': '试听课仅支持提前半小时约课／调课／取消',
    'AT_6': '请提前1小时约课',
    'AT_7': '请提前15分钟取消',
    'AT_8': '请提前15分钟修改／调课',
    'AT_9': '请提前12小时约课／调课／取消',
    'AT_10': '请提前12小时约课／调课／取消',
    'AT_11': '请提前12小时约课／调课／取消',
    'AT_13': '请提在上课前取消内部预约',
    'B_0': '无效的手机格式',
    'B_1': '验证码发送频繁,请稍后再试',
    'B_2': '验证码发送频繁,请稍后再试',
    'B_3': '验证码发送失败',
    'B_4': '验证码错误',
    'B_5': '用户已存在',
    'B_6': 'teacher_does_not_exist',
    'B_7': '用户名或密码有误',
    'B_8': '账号不存在或密码错误',
    'B_9': '重置密码失效，请重新验证手机号',
    'B_10': '请填写新密码',
    'B_16': '该手机号已被使用',
    'B_21': '验证码发送频繁，30分钟后重试',
    'B_22': '用户不存在',
    'B_23': '该邮箱已经绑定',
    'B_24': '邮箱无效，请输入与北森系统录入一致的邮箱',
    'C_0': 'http_request_failed',
    'C_1': 'qq_error_received',
    'CC_12': '本课程已通过',
    'CC_13': '提交记录不存在',
    'CC_14': '学生已提交新作品，请刷新后查看',
    'CC_15': '更新提交记录失败',
  },
  // 营销相关
  market: {
    'Platform-Other-Fail@Codemaster-Marketing-Api': '系统繁忙，请稍后再试',
  },
};

// 将树状结构的字典转换成单层结构
const objToRecord = (obj:ICodeParse, result?:Record<string, string>) => {
  result = result || {};
  for (const key in obj) {
    const item = obj[key];
    if (item instanceof Object) {
      objToRecord(item, result);
    } else {
      result[key] = item;
    }
  }
  return result;
};

export const errorParse = (code:string) => {
  const parse = result || objToRecord(codeParse, result);
  return code in parse ? parse[code] : '未知错误';
};

